'use client';

import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DISMISSED_KEY = 'curiko-archive-banner-dismissed-v3';

const BannerWrapper = styled.div`
  background: #ffe51d;
  color: #251628;
  padding: 14px 52px 14px 24px;
  text-align: center;
  font-family: var(--font-work-sans), sans-serif;
  font-size: 14px;
  line-height: 1.65;
  position: relative;
  /* Stay above fixed page backdrops such as the home page starfield (z-index 1) */
  z-index: 1300;
  border-bottom: 1px solid rgba(37, 22, 40, 0.15);
`;

const BannerText = styled.p`
  margin: 0;
  & + & {
    margin-top: 12px;
  }
`;

const CloseBtn = styled(IconButton)`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #251628;
  padding: 4px;
  &:hover {
    background-color: rgba(37, 22, 40, 0.1);
  }
`;

const LearnLink = styled.a`
  color: #251628;
  font-weight: 600;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
    color: #251628;
  }
`;

export default function ArchiveBanner() {
  // Start as dismissed to prevent hydration flash; useEffect reveals it if not dismissed
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    setDismissed(!!localStorage.getItem(DISMISSED_KEY));
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, '1');
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <BannerWrapper role="banner">
      <BannerText>
        <LearnLink href="https://www.curiko.ca/goodbye" target="_blank" rel="noopener noreferrer">
          <strong>Curiko operated from 2021&ndash;2026</strong>
        </LearnLink>
        , and its predecessor Kudoz ran from 2015&ndash;2021.
      </BannerText>
      <BannerText>
        While our platform is not currently active, this website remains so others can explore how
        Curiko worked and apply its approach. We&apos;re working on a website to share more about
        the research, impact, frameworks, R&amp;D process, and key lessons. Stay tuned.
      </BannerText>
      <CloseBtn onClick={dismiss} aria-label="Dismiss announcement">
        <CloseIcon fontSize="small" />
      </CloseBtn>
    </BannerWrapper>
  );
}
